import * as React from "react"
import { styled } from "@mui/material/styles"
import Grid from "@mui/material/Grid"
import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"
import ResourcesGrid from "../../features/resources-grid/ResourcesGrid"
import ResourcesCategories from "../../features/resources-categories/ResourcesCategories"
import Item from "@mui/material/Grid"
import { green } from "@mui/material/colors"
import { makeStyles } from "@material-ui/core/styles"
import { minHeight, minWidth, palette } from "@mui/system"
import { BsFillTelephoneFill } from "react-icons/bs"
import { Typography } from "@mui/material"
import {HiMail} from "react-icons/hi"
import {MdLocationPin} from "react-icons/md"
import {AiFillClockCircle} from "react-icons/ai"

const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      backgroundColor: theme.palette.background.paper,
      maxWidth: "100%",
      borderRadius: "25px",
      minHeight: "200%",
    },
    missionShell: {
      borderRadius: "20px",
      width: "1196px",
      height: "364px",
      display: "flex",
      marginTop:"40px",
      margin: "auto",
      paddingLeft: "15px",
      paddingBottom: "15px",
      justifyContent: "center",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      boxShadow: "0px 0px 60px rgba(149, 163, 127, 0.8)",
    },
    descriptionShell: {
        borderRadius: "20px",
        width: "964px",
        height: "744px",
        display: "flex",
        paddingTop: "16px",
        margin: "auto",
        paddingLeft: "15px",
        paddingBottom: "15px",
        justifyContent: "center",
    },
    missionHeader: {
        fontFamily: "Arvo",
        fontWeight: "bold",
        textAlign: "center",
        fontStyle: "italic",
        fontSize: "24px",
        justifyContent: "center",
        marginTop: "20px",
    },
    missionDescription: {
        fontFamily: "DM Sans",
        justifyContent: "center",   
        fontSize: "24px",
        marginTop: "20px",
    },
    descriptionBelow: {
        fontFamily: "DM Sans",
        justifyContent: "center",   
        fontSize: "24px",
        marginTop: "40px",
    },
    mainHeader: {
        fontFamily: "Arvo",
        fontSize: "40px",
        fontWeight: "bold",
        justifyContent: "center",
        margin: "auto",
        marginTop: "120px",
    },
  }))
  
function OuterShell() {
    const classes = useStyles()
    return (
        <div> 
            <div className={classes.missionShell}>
                <Grid>
                    <Mission />
                </Grid>
            </div>
            <div className={classes.descriptionShell}> 
                <Grid>
                    <Description />
                </Grid>
            </div>
      </div>
        
    )
  }

function Mission() {
    const classes = useStyles()
    return (
        <div>
            <h1 className={classes.missionHeader}>Our Mission</h1>
            <p className={classes.missionDescription}> Due to the COVID-19 pandemic, all Los Angeles community and social programs are 
            stretched to the limit, affecting our Southern California communities in all areas, including business and residential, education 
            and schools, street beautification, fire, police, water quality, transportation, the arts, homelessness, senior citizens, parks and 
            recreation, green programs, safety and disaster preparedness.  We focus our philanthropic efforts on community programs of inclusion, 
            youth education and employment, family health, social equity, social justice and community engagement.</p>
        </div>
    )
}

function Description() {
    const classes = useStyles()
    return (
        <div>
            <p className={classes.descriptionBelow}> Our executive board leadership experience has resulted in multiple programs totaling 
            more than 120+ years in program administration, operation, and implementation.  Sheryl Turner is our CEO and Kuliema Blueford 
            is our Program Director. Our five board members include people of color, women, veterans and the disabled. 
            <br></br> <br></br>
            Board members and staff have extensive experience serving at-risk and minority populations and consistently embrace the BIPOC community.  
            We develop and implement strategies that meet the needs of this critical constituency.  Our programming is developed through a lens of 
            Diversity, Equity, and Inclusion (DEI). Each program component and partner has developed this culture internally to ensure BIPOC individuals 
            and groups that typically face bias will feel comfortable and confident navigating the journey from expungement to employment and training.  
            <br></br> <br></br>
            Our experience operating publicly funded workforce development programs has been continuous since 2004.  Our leadership has provided 
            services on behalf of YouthBuild America, Mid-City West Community Council of Los Angeles, Pasadena Unified School District, the Jackie 
            Robinson Center food programs for youth, and other privately funded programs serving high-risk communities.  Each of these programs has 
            featured a unique delivery model and has emphasized services to distinct target groups.  The program's basic structure concentrates service 
            delivery from a single point of access - a one-stop-shop system.  We offer 25 years' experience of successful oversight and operations of 
            multi-million dollar publicly funded JTPA, WIA and WIOA:  Adult, Dislocated Worker and Youth programming.
            <br></br> <br></br> <br></br> <br></br>
            </p>
        </div>
    )
}
  

function AboutUs() {
    const classes = useStyles()
    return (
    <Grid
        container
        sx={{
          width: "90%",
          margin: "auto",
        }}
    >
        <Grid item xs={12}>
            <div>
                <h1 className={classes.mainHeader}>About Us</h1>
                <div>
                <OuterShell />
                </div>
                <br></br> <br></br>
                <br></br> <br></br>
                <br></br> <br></br>
                <br></br> <br></br>

            </div>
        </Grid>
    </Grid>
    )
  }
  export default AboutUs
  